export default {
  theme: {
    extend: {
      opacity: {
        40: '0.4',
        60: '0.6',
        85: '0.85',
      },
      boxShadow: {
        1: '5px 0px 10px 0px rgba(0, 0, 0, 0.03)',
        2: '0px 5px 10px 0px rgba(0, 0, 0, 0.06)',
        3: '0px 2px 6px 0px rgba(0, 0, 0, 0.03)',
        4: '0px 4px 6px rgba(0, 0, 0, 0.09)',
        5: '0px 7px 17px 1px rgba(0, 0, 0, 0.08)',
        6: '0px 4px 6px rgba(0, 0, 0, 0.05)',
        7: '0px 4px 17px 0px rgba(0, 0, 0, 0.24)',
        8: '0px 13px 44px 0px rgba(0, 0, 0, 0.15)',
      },
      dropShadow: {
        1: '0px 4px 4px rgba(0, 0, 0, 0.10)',
        2: '0px 4px 9px rgba(0, 0, 0, 0.11)',
        3: '0px 2px 6px rgba(0, 0, 0, 0.02)',
        teal: '0px 3px 12px rgba(61, 249, 204, 0.52)',
        yellow: '0px 5px 15px rgba(255, 219, 75, 0.52)',
        orange: '0px 5px 15px rgba(255, 159, 75, 0.52)',
        red: '0px 3px 12px rgba(255, 118, 120, 0.52)',
        blue: '0px 3px 12px rgba(96, 173, 255, 0.52)',
      },
      fontFamily: {
        poppins: ['Poppins', 'Arial', 'sans-serif'],
        noto: ['Noto Sans', 'sans-serif'],
        cjk: ['Noto Sans KR', 'sans-serif'],
      },
      colors: {
        datepicker: {
          DEFAULT: '#CCD3D9',
          dark: '#7E8993',
        },
        teal: {
          light: '#18B5D4',
          main: '#0092B3',
          dark: '#00748E',
        },
        orange: {
          light: '#FFA062',
          main: '#ff7e33',
          dark: '#FF6A23',
        },
        blue: {
          light: '#467EFF',
          main: '#265CD9',
          dark: '#0036B4',
        },
        red: {
          light: '#FF4C4F',
          main: '#D7282B',
          dark: '#B70003',
        },
        yellow: {
          light: '#FFE065',
          main: '#FFCC00',
          dark: '#DFB300',
        },
        dark: {
          1: '#11AFCE',
          2: '#171e26',
          3: '#242e38',
          4: '#2f3a46',
          5: '#394653',
          6: '#3f4c5a',
          7: '#475462',
          8: '#55616e',
          9: '#616f7d',
          10: '#6f7b87',
        },
        light: {
          1: '#ffffff',
          2: '#f3f6f8',
          3: '#e4e9ed',
          4: '#d6dee4',
          5: '#ccd3d9',
          6: '#bec4ca',
          7: '#acb4bb',
          8: '#98a2ab',
          9: '#87929d',
          10: '#7e8993',
        },
      },
    },
  },
  content: [
    './src/**/*.{js,jsx,ts,tsx}',
    'node_modules/flowbite-react/dist/esm/**/*.mjs',
  ],
  plugins: [
    function ({ addComponents, addUtilities }) {
      addUtilities({
        '.underline-offset-2px': {
          'text-underline-offset': '2px',
        },
      });
      addComponents({
        '.noto-title-bold': {
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontWeight: '700',
        },
        '.noto-body-small': {
          fontFamily: 'Noto Sans',
          fontSize: '12px',
          fontWeight: '400',
        },
        '.pop-title-bold': {
          fontFamily: 'Poppins',
          fontSize: '21px',
          fontWeight: '700',
        },
        // Noto Sans pixel 기준 {family}-{size}-{weight}
        '.noto-11-bold': {
          fontFamily: 'Noto Sans',
          fontSize: '11px',
          fontWeight: '700',
        },
        '.noto-11-light': {
          fontFamily: 'Noto Sans',
          fontSize: '11px',
          fontWeight: '300',
        },
        '.noto-11-semibold': {
          fontFamily: 'Noto Sans',
          fontSize: '11px',
          fontWeight: '600',
        },
        '.noto-11-normal': {
          fontFamily: 'Noto Sans',
          fontSize: '11px',
          fontWeight: '400',
        },
        '.noto-11-medium': {
          fontFamily: 'Noto Sans',
          fontSize: '11px',
          fontWeight: '500',
        },
        '.noto-12-normal': {
          fontFamily: 'Noto Sans',
          fontSize: '12px',
          fontWeight: '400',
        },
        '.noto-12-medium': {
          fontFamily: 'Noto Sans',
          fontSize: '12px',
          fontWeight: '500',
        },
        '.noto-13-light': {
          fontFamily: 'Noto Sans',
          fontSize: '13px',
          fontWeight: '300',
        },
        '.noto-13-medium': {
          fontFamily: 'Noto Sans',
          fontSize: '13px',
          fontWeight: '500',
        },
        '.noto-13-bold': {
          fontFamily: 'Noto Sans',
          fontSize: '13px',
          fontWeight: '700',
        },
        '.noto-13-semibold': {
          fontFamily: 'Noto Sans',
          fontSize: '13px',
          fontWeight: '600',
        },
        '.noto-13-normal': {
          fontFamily: 'Noto Sans',
          fontSize: '13px',
          fontWeight: '400',
        },
        '.noto-14-normal': {
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontWeight: '400',
        },
        '.noto-14-light': {
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontWeight: '300',
        },
        '.noto-14-medium': {
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontWeight: '500',
        },
        '.noto-14-semibold': {
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontWeight: '600',
        },
        '.noto-14-bold': {
          fontFamily: 'Noto Sans',
          fontSize: '14px',
          fontWeight: '700',
        },
        '.noto-15-medium': {
          fontFamily: 'Noto Sans',
          fontSize: '15px',
          fontWeight: '500',
        },
        // NotoSans KR
        '.cjk-13-normal': {
          fontFamily: 'Noto Sans KR',
          fontSize: '13px',
          fontWeight: '400',
        },
        '.cjk-13-medium': {
          fontFamily: 'Noto Sans KR',
          fontSize: '13px',
          fontWeight: '500',
        },
        // Poppins pixel 기준 {family}-{size}-{weight}
        '.pop-10-medium': {
          fontFamily: 'Poppins',
          fontSize: '10px',
          fontWeight: '500',
        },
        '.pop-11-normal': {
          fontFamily: 'Poppins',
          fontSize: '11px',
          fontWeight: '400',
        },
        '.pop-11-semibold': {
          fontFamily: 'Poppins',
          fontSize: '11px',
          fontWeight: '600',
        },
        '.pop-11-bold': {
          fontFamily: 'Poppins',
          fontSize: '11px',
          fontWeight: '700',
        },
        '.pop-12-normal': {
          fontFamily: 'Poppins',
          fontSize: '12px',
          fontWeight: '400',
        },
        '.pop-13-normal': {
          fontFamily: 'Poppins',
          fontSize: '13px',
          fontWeight: '400',
        },
        '.pop-13-medium': {
          fontFamily: 'Poppins',
          fontSize: '13px',
          fontWeight: '500',
        },
        '.pop-13-semibold': {
          fontFamily: 'Poppins',
          fontSize: '13px',
          fontWeight: '600',
        },
        '.pop-14-bold': {
          fontFamily: 'Poppins',
          fontSize: '14px',
          fontWeight: '700',
        },
        '.pop-17-semibold': {
          fontFamily: 'Poppins',
          fontSize: '17px',
          fontWeight: '600',
        },
        '.pop-18-semibold': {
          fontFamily: 'Poppins',
          fontSize: '18px',
          fontWeight: '600',
        },
        '.pop-18-bold': {
          fontFamily: 'Poppins',
          fontSize: '18px',
          fontWeight: '700',
        },
        '.pop-40-bold': {
          fontFamily: 'Poppins',
          fontSize: '40px',
          fontWeight: '700',
        },
        '.pop-60-bold': {
          fontFamily: 'Poppins',
          fontSize: '60px',
          fontWeight: '700',
        },
        '.pop-menu-bold': {
          fontFamily: 'Poppins',
          fontSize: '13px',
          fontWeight: '700',
        },
        '.pop-menu-semibold': {
          fontFamily: 'Poppins',
          fontSize: '13px',
          fontWeight: '600',
        },
        '.pop-menu-normal': {
          fontFamily: 'Poppins',
          fontSize: '13px',
          fontWeight: '400',
        },
        '.pop-15-normal': {
          fontFamily: 'Poppins',
          fontSize: '15px',
          fontWeight: '400',
        },
        // rem 기준 {family}-{weight}-{rem}
        '.noto-light-3': {
          fontFamily: 'Noto Sans',
          fontSize: '0.75rem',
          fontWeight: '300',
        },
        '.noto-normal-3': {
          fontFamily: 'Noto Sans',
          fontSize: '0.75rem',
          fontWeight: '400',
        },
        '.noto-normal-4': {
          fontFamily: 'Noto Sans',
          fontSize: '1rem',
          fontWeight: '400',
        },
        '.noto-semibold-3': {
          fontFamily: 'Noto Sans',
          fontSize: '0.75rem',
          fontWeight: '600',
        },
        '.noto-semibold-4': {
          fontFamily: 'Noto Sans',
          fontSize: '1rem',
          fontWeight: '600',
        },
        '.noto-bold-3': {
          fontFamily: 'Noto Sans',
          fontSize: '0.75rem',
          fontWeight: '700',
        },
        '.noto-bold-4': {
          fontFamily: 'Noto Sans',
          fontSize: '1rem',
          fontWeight: '700',
        },
        '.noto-medium-4': {
          fontFamily: 'Noto Sans',
          fontSize: '1rem',
          fontWeight: '500',
        },
        '.noto-medium-3': {
          fontFamily: 'Noto Sans',
          fontSize: '0.75rem',
          fontWeight: '500',
        },
        '.pop-normal-3': {
          fontFamily: 'Poppins',
          fontSize: '0.75rem',
          fontWeight: '400',
        },
        '.pop-medium-3': {
          fontFamily: 'Poppins',
          fontSize: '0.75rem',
          fontWeight: '500',
        },
        '.pop-semibold-4': {
          fontFamily: 'Poppins',
          fontSize: '1rem',
          fontWeight: '600',
        },
        '.pop-semibold-5': {
          fontFamily: 'Poppins',
          fontSize: '1.25rem',
          fontWeight: '600',
        },
        '.pop-bold-3': {
          fontFamily: 'Poppins',
          fontSize: '0.75rem',
          fontWeight: '700',
        },
        '.pop-bold-5': {
          fontFamily: 'Poppins',
          fontSize: '1.25rem',
          fontWeight: '700',
        },
        '.pop-bold-6': {
          fontFamily: 'Poppins',
          fontSize: '1.5rem',
          fontWeight: '700',
        },
      });
    },
  ],
};
